// removed by extract-text-webpack-plugin
module.exports = {"root":"SocialSharingList-module-root-2Wlyo","item":"SocialSharingList-module-item-28m6B","icon-messenger":"SocialSharingList-module-icon-messenger-bw9M-","iconMessenger":"SocialSharingList-module-icon-messenger-bw9M-","item-messanger":"SocialSharingList-module-item-messanger-1T6TR","itemMessanger":"SocialSharingList-module-item-messanger-1T6TR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SocialSharingList/SocialSharingList.module.scss
// module id = 1185
// module chunks = 0